var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mx-2",attrs:{"loading":_vm.loading,"fab":"","dark":"","x-small":"","color":"primary"},on:{"click":function($event){return _vm.loadMembresDugroupe(_vm.groupe.id)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" mdi-reload ")])],1)]}}])},[_c('span',[_vm._v("Générer les ménages")])])}
var staticRenderFns = []

export { render, staticRenderFns }